import { BorderType } from '../../../../common/constants/border-type';
import { DateWithTimezones } from '../../../../common/models/status-history-chain.model';
import { SCode } from '../../../../common/constants/scode-status';
import { LinkInfoType, MilestoneType } from '../../../models/shipment-status-chain.model';

export class ShipmentTransportOrderStatusChainModel {
  active: boolean;
  actualDate: DateWithTimezones;
  address: string;
  code: SCode;
  description: string;
  descriptionActive: boolean;
  estimatedDate: DateWithTimezones;
  index: number;
  linkInfoType: LinkInfoType;
  linkType: BorderType;
  major: boolean;
  passed: boolean;
  secondarySource: boolean;
  title: string;
  titleAddress: string;
  type: MilestoneType;
  transportName: string;
}
